export const RevGuardRegType = {
  LegalEntity: 'Legal Entity',
  NaturalPerson: 'Natural Person',
};
